import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { UseFormReturn } from "react-hook-form";
import { OfferFormValues } from "../../../schemas/offerFormSchema";
import { Offer } from "@/types/offer";
import { PricingSection } from "./PricingSection";
import { TimingSection } from "./TimingSection";

interface PricingAndTimingCardProps {
  form: UseFormReturn<OfferFormValues>;
  markFieldAsModified?: (fieldName: string) => void;
  isFieldModified?: (fieldName: string) => boolean;
  resetFieldToProgram?: (fieldName: string) => void;
  hasInitialOffer?: boolean;
  initialOffer?: Offer | null;
}

export const PricingAndTimingCard: React.FC<PricingAndTimingCardProps> = ({
  form,
  markFieldAsModified = () => {},
  isFieldModified = () => false,
  resetFieldToProgram = () => {},
  hasInitialOffer = false,
  initialOffer = null
}) => {
  // Monitor the variation to update the UI
  const variation = form.watch("variation");
  const variationKey = form.watch("variationKey");
  
  return (
    <Card>
      <CardContent className="pt-6 bg-slate-100">
        <div className="mb-4">
          <p className="font-normal text-slate-700 text-sm">
            These values are automatically set from the program's value (once published). Or you can customize them.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            {/* Add key based on variation to force re-render when program changes */}
            <PricingSection 
              key={`pricing-${variationKey}`}
              form={form} 
              markFieldAsModified={markFieldAsModified} 
              isFieldModified={isFieldModified} 
              resetFieldToProgram={resetFieldToProgram} 
              showHeaders={false} 
            />
          </div>
          <div>
            {/* Add key based on variation to force re-render when program changes */}
            <TimingSection 
              key={`timing-${variationKey}`}
              form={form} 
              markFieldAsModified={markFieldAsModified} 
              isFieldModified={isFieldModified} 
              resetFieldToProgram={resetFieldToProgram} 
              showHeaders={false} 
              hasInitialOffer={hasInitialOffer}
              initialOffer={initialOffer}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
